'use client';

import { Scores } from '@/modules/league/new-components/matches-components/MatchesComponent/MatchCard/MatchCard';
import { MatchesPlayers } from '@/modules/league/new-components/types';
import { getMatchColor } from '@/utils/actions/leagues/gameDay/functions/getMatchColor';
import { getScorePl } from '@/utils/actions/leagues/gameDay/functions/getScores';
interface ScoreSectionProps {
  player: MatchesPlayers;
  team1Wins: number;
  team2Wins: number;
  scores: Scores;
}

interface ScoreBox {
  player: MatchesPlayers;
  indexOfPlayer: number;
  teamNumber: number;
  isMatchCanceled: boolean;
  team1Wins: number;
  team2Wins: number;
  scores: Scores;
}

const ScoreBox = ({
  player,
  indexOfPlayer,
  teamNumber,
  isMatchCanceled,
  team1Wins,
  team2Wins,
  scores,
}: ScoreBox) => {
  const score = isMatchCanceled === false ? getScorePl(scores, teamNumber, indexOfPlayer) : 'C';
  const groupOrder = teamNumber === 1 ? [1, 2] : [2, 1];
  return (
    <div
      className={`flex h-[30px] w-[26px] items-center justify-center rounded-md border ${getMatchColor(
        player,
        indexOfPlayer,
        groupOrder,
        team1Wins,
        team2Wins
      )} ${isMatchCanceled ? '!border-gray-900 !bg-gray-300/70 font-bold !text-gray-900' : ''}`}
    >
      <span className='text-sm font-bold'>{score.toString()}</span>
    </div>
  );
};

export const ScoreSection = ({ player, team1Wins, team2Wins, scores }: ScoreSectionProps) => (
  <div className='my-4 flex flex-col items-center justify-center'>
    <div className='flex flex-row items-center gap-2'>
      {(() => {
        const rows = [];
        for (let i = 1; i <= player.MaxGames; i++) {
          rows.push(
            <ScoreBox
              key={`team1-game-${i}`}
              player={player}
              indexOfPlayer={i}
              teamNumber={1}
              isMatchCanceled={player.DidCancelMatch}
              team1Wins={team1Wins}
              team2Wins={team2Wins}
              scores={scores}
            />
          );
        }
        return rows;
      })()}
    </div>
    <div className='flex w-full flex-row items-center justify-center'>
      <div className='w-full border-t-[0.5px] border-gray-200 px-2 md:block' />
      <div className='my-4 px-4 text-xs uppercase text-gray-300'>vs</div>
      <div className='w-full border-t-[0.5px] border-gray-200 px-2 md:block' />
    </div>

    <div className='flex flex-row items-center gap-2'>
      {(() => {
        const rows = [];
        for (let i = 1; i <= player.MaxGames; i++) {
          rows.push(
            <ScoreBox
              key={`team2-game-${i}`}
              player={player}
              indexOfPlayer={i}
              teamNumber={2}
              isMatchCanceled={player.DidCancelMatch}
              team1Wins={team1Wins}
              team2Wins={team2Wins}
              scores={scores}
            />
          );
        }
        return rows;
      })()}
    </div>
  </div>
);
